const slugOrder = [
  'intro',  // Keep this first
  'relay-or-donate',
  'choosing-a-host',
  'install-tor-daemon',

  'thank-you'  // Keep this last
];

export default slugOrder;
